// src/components/charts/RunsPerDayLine.jsx
//
// Population-true line chart of runs per day. Sourced from /runs/stats?group_by=day.
// BE returns dense buckets — keep zero-days visible (no client-side filtering).
//
import React from 'react';
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,
} from 'recharts';

function formatDateTick(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('it-IT', { day: 'numeric', month: 'short' });
}

/**
 * Transform a `groupBy=day` stats response into Recharts shape.
 * Buckets are dense and chronologically ordered by the BE.
 * Exported for unit testing.
 */
export function toLineRows(stats) {
  if (!stats?.buckets) return [];
  return stats.buckets.map((b) => ({ date: b.key, count: b.count || 0 }));
}

export default function RunsPerDayLine({ data }) {
  const rows = toLineRows(data);
  if (rows.length === 0) return null;
  return (
    <ResponsiveContainer width="100%" height={220}>
      <LineChart data={rows} margin={{ top: 8, right: 16, bottom: 0, left: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.06)" />
        <XAxis dataKey="date" tickFormatter={formatDateTick} tick={{ fontSize: 11, fill: '#6c6c6d' }} />
        <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: '#6c6c6d' }} />
        <Tooltip
          labelFormatter={formatDateTick}
          contentStyle={{ fontSize: 12, fontFamily: "'DM Sans', sans-serif" }}
        />
        <Line type="monotone" dataKey="count" stroke="#1d1d1f" strokeWidth={2} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  );
}
